import React, { useEffect, useState } from "react";
import { Save, Trash2, FolderOpen } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Save / load the student's own grooves (stored in their account).
export const SavedGrooves = ({ level, grid, bpm, onLoad, testId }) => {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [name, setName] = useState("");
  const [msg, setMsg] = useState("");
  const load = () => api.get("/me/grooves").then(({ data }) => setList(data)).catch(() => {});
  useEffect(() => { if (user) load(); }, [user]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!user) return <p className="mt-3 text-xs text-muted-foreground" data-testid={`${testId}-login-hint`}>Log in to save your grooves to your account.</p>;
  const save = async () => {
    setMsg("");
    try {
      await api.post("/me/grooves", { name: name.trim() || `My groove ${list.length + 1}`, level, bpm, grid: Object.fromEntries(Object.entries(grid).map(([r, s]) => [r, [...s]])) });
      setName(""); setMsg("Saved to your account."); load();
    } catch (e) { setMsg(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  const remove = async (id) => { await api.delete(`/me/grooves/${id}`).catch(() => {}); setMsg(""); load(); };
  return (
    <div className="mt-4 rounded-xl border border-border p-3" data-testid={`${testId}-saved`}>
      <div className="flex flex-wrap items-center gap-2">
        <input value={name} onChange={(e) => setName(e.target.value)} maxLength={40} placeholder="Name your groove" data-testid={`${testId}-name`}
          className="h-9 flex-1 rounded-full border border-border bg-background px-4 text-sm" />
        <button onClick={save} data-testid={`${testId}-save`} className="inline-flex items-center gap-1.5 rounded-full bg-primary px-4 py-2 text-xs font-semibold text-primary-foreground"><Save size={12} /> Save my groove</button>
      </div>
      {msg && <p className="mt-2 text-xs text-muted-foreground" data-testid={`${testId}-msg`}>{msg}</p>}
      {list.length > 0 && (
        <ul className="mt-3 space-y-1.5" data-testid={`${testId}-list`}>
          {list.map((g) => (
            <li key={g.id} className="flex items-center gap-2 text-sm" data-testid={`${testId}-item-${g.id}`}>
              <span className="flex-1 truncate">{g.name} <span className="text-xs text-muted-foreground">· {g.bpm} BPM{g.level !== level ? ` · level ${g.level}` : ""}</span></span>
              <button onClick={() => onLoad(g)} data-testid={`${testId}-load-${g.id}`} className="inline-flex items-center gap-1 rounded-full border border-border px-3 py-1 text-xs hover:border-primary"><FolderOpen size={12} /> Open</button>
              <button onClick={() => remove(g.id)} aria-label={`Delete ${g.name}`} data-testid={`${testId}-delete-${g.id}`} className="rounded-full p-1.5 text-muted-foreground hover:text-red-400"><Trash2 size={13} /></button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
